import { render, staticRenderFns } from "./RequestWorkTypesList.vue?vue&type=template&id=73cb4868&scoped=true&"
import script from "./RequestWorkTypesList.vue?vue&type=script&lang=js&"
export * from "./RequestWorkTypesList.vue?vue&type=script&lang=js&"
import style0 from "./RequestWorkTypesList.vue?vue&type=style&index=0&id=73cb4868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cb4868",
  null
  
)

export default component.exports
import {QCardActions,QBtn,QIcon,QTooltip,QBtnToggle,QCheckbox,QExpansionItem,QItemLabel,QItem} from 'quasar'
component.options.components = Object.assign({QCardActions,QBtn,QIcon,QTooltip,QBtnToggle,QCheckbox,QExpansionItem,QItemLabel,QItem}, component.options.components || {})
